module.exports = __webpack_public_path__ + "img/login.ff40e6eb.png";